import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconNames,
  IconVariant,
  Space,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { DashboardActionData } from '@library/api-customer-engagement-experience'

const ICON_MAP: Record<string, IconNames> = {
  resub: 'resub',
}

const FALLBACK_ICON: IconNames = 'resub'

const PromptCard = withCitrusTheme('button', (theme) => ({
  appearance: 'none',
  border: 'none',
  width: '100%',
  textAlign: 'left',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.color(Color.White),
  borderRadius: '4px',
  padding: `${theme.spacing(4)}px`,
  boxShadow: '0px 0px 2px 0px #2129300D, 0px 1px 4px 0px #2129301A',
  transition: 'box-shadow 150ms ease-in-out',
  '&:hover': {
    boxShadow: '0 12px 16px -4px rgba(33, 41, 48, 0.06), 0 4px 6px -2px rgba(33, 41, 48, 0.03)',
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.color(Color.Secondary_400)}`,
    outlineOffset: '2px',
  },
}))

export type RegularDeliveryPromptProps = {
  data: DashboardActionData
  onAction: (intent: string) => void
}

export const RegularDeliveryPrompt = ({ data, onAction }: RegularDeliveryPromptProps) => {
  const { title, subtitle, icon, intent } = data
  const iconName = ICON_MAP[icon] ?? FALLBACK_ICON

  const handleClick = () => {
    onAction(intent)
  }

  return (
    <PromptCard type="button" aria-label={title} data-intent={intent} onClick={handleClick}>
      <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
        <Box color={Color.Secondary_400} display={Display.Flex} alignItems={AlignItems.Center}>
          <Icon aria-hidden="true" name={iconName} size={8} variant={IconVariant.Inherit} />
        </Box>
        <Space size={3} direction="horizontal" />
        <Box>
          <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={4}>
            {title}
          </Text>
          <Text color={Color.ColdGrey_600} size={2}>
            {subtitle}
          </Text>
        </Box>
      </Box>
      <Box color={Color.Secondary_400} display={Display.Flex} alignItems={AlignItems.Center}>
        <Icon aria-hidden="true" name="arrow_right" size={6} variant={IconVariant.Inherit} />
      </Box>
    </PromptCard>
  )
}
